import type { SVGProps } from "react";
export function Copy(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-slot="icon"
      {...props}
    >
      <clipPath id="a">
        <path d="m0 0h16v16h-16z" />
      </clipPath>
      <g
        clipPath="url(#a)"
        clipRule="evenodd"
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d="m1.88463 1.69425c-.08438 0-.15278.06841-.15278.15278v1.04801c0 .25313-.2052.45833-.45833.45833s-.458334-.2052-.458334-.45833v-1.04801c0-.59064.478804-1.069442 1.069444-1.069442h1.048c.25313 0 .45834.205203.45834.458332 0 .25313-.20521.45833-.45834.45833zm3.38122-.45833c0-.253129.2052-.458332.45833-.458332h2.04085c.25313 0 .45833.205203.45833.458332 0 .25313-.2052.45833-.45833.45833h-2.04085c-.25313 0-.45833-.2052-.45833-.45833zm4.79985 0c0-.253129.2052-.458332.4583-.458332h.9756c.5905 0 1.0694.478782 1.0694 1.069442v1.04801c0 .25313-.2052.45833-.4583.45833s-.4583-.2052-.4583-.45833v-1.04801c0-.08435-.0685-.15278-.1528-.15278h-.9756c-.2531 0-.4583-.2052-.4583-.45833zm-8.79218 3.99233c.25313 0 .45833.2052.45833.45833v2.04087c0 .25313-.2052.45833-.45833.45833s-.458334-.2052-.458334-.45833v-2.04087c0-.25313.205204-.45833.458334-.45833zm0 4.79985c.25313 0 .45833.2052.45833.4583v.9755c0 .0844.0684.1528.15278.1528h1.048c.25313 0 .45834.2052.45834.4584 0 .2531-.20521.4583-.45834.4583h-1.048c-.59063 0-1.069444-.4788-1.069444-1.0695v-.9755c0-.2531.205204-.4583.458334-.4583z" />
        <path d="m5.11393 4.99816c-.08437 0-.15278.0684-.15278.15278v9.00196c0 .0844.06843.1528.15278.1528h9.00197c.0843 0 .1528-.0684.1528-.1528v-9.00196c0-.08438-.0684-.15278-.1528-.15278zm-1.06944.15278c0-.59064.47881-1.06945 1.06944-1.06945h9.00197c.5906 0 1.0694.47882 1.0694 1.06945v9.00196c0 .5906-.4787 1.0695-1.0694 1.0695h-9.00197c-.59066 0-1.06944-.4789-1.06944-1.0695z" />
      </g>
    </svg>
  );
}
